export default __webpack_public_path__ + "static/media/photo-owner-2__2x.02427a13.png";